import axios from 'axios';

export default {
  fetchResellerAgentList({
    commit,
  }, paginationParams) {
    commit('setLoading', true);
    commit('setError', false);

    return axios.get('/resellerAgent', {
      params: paginationParams,
    })
      .then((resellerAgents) => {
        commit('setData', resellerAgents);
      })
      .catch((err) => {
        commit('setError', err);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
  deleteResellerAgent(_, resellerAgent) {
    return axios.delete(`/resellerAgent/${resellerAgent.id}`);
  },
};
